module.exports = __webpack_public_path__ + "static/media/RidesOne.16900e7e.jpg";